import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from './components/LandingPage';
import DesprePage from './components/DesprePage';
import EpisoadePage from './components/EpisoadePage';
import StudiiPage from './components/StudiiPage';
import RugaciuniPage from './components/RugaciuniPage';
import ContactPage from './components/ContactPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/despre" element={<DesprePage />} />
          <Route path="/episoade" element={<EpisoadePage />} />
          <Route path="/studii" element={<StudiiPage />} />
          <Route path="/rugaciuni" element={<RugaciuniPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;